// src/components/admin/AdminNews.js

import React, { useState, useEffect } from 'react';
import { db } from '../../firebase';
import { collection, getDocs, addDoc, deleteDoc, doc, updateDoc, query, orderBy } from 'firebase/firestore';
import toast from 'react-hot-toast';

const AdminNews = () => {
    const [newsList, setNewsList] = useState([]);
    const [title, setTitle] = useState('');
    const [content, setContent] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        fetchNews();
    }, []);

    const fetchNews = async () => {
        try {
            const q = query(collection(db, 'news'), orderBy('createdAt', 'desc'));
            const snap = await getDocs(q);
            setNewsList(snap.docs.map(d => ({ id: d.id, ...d.data() })));
        } catch (e) {
            console.error("お知らせ取得エラー", e);
        }
    };

    const handleAdd = async () => {
        if (!title.trim() || !content.trim()) {
            return toast.error('タイトルと本文を入力してください');
        }
        
        setLoading(true);
        try {
            await addDoc(collection(db, 'news'), {
                title: title.trim(),
                content: content.trim(),
                isActive: true, // デフォルトで表示状態にする
                createdAt: new Date().toISOString()
            });
            setTitle(''); 
            setContent('');
            toast.success('お知らせを公開しました！');
            fetchNews();
        } catch (e) {
            console.error(e);
            toast.error('公開に失敗しました');
        } finally {
            setLoading(false);
        }
    };

    const toggleActive = async (id, currentStatus) => {
        try {
            await updateDoc(doc(db, 'news', id), { isActive: !currentStatus });
            toast.success(currentStatus ? '非表示にしました' : '表示しました');
            fetchNews();
        } catch (e) {
            console.error(e);
            toast.error('状態の変更に失敗しました');
        }
    };

    const handleDelete = async (id) => {
        if (!window.confirm('本当にこのお知らせを削除しますか？\n（この操作は取り消せません）')) return;
        try {
            await deleteDoc(doc(db, 'news', id));
            toast.success('削除しました');
            fetchNews();
        } catch (e) {
            console.error(e);
            toast.error('削除に失敗しました');
        }
    };

    return (
        <div>
            {/* 新規作成パネル */}
            <div className="card" style={{ borderTop: '4px solid #ff9800' }}>
                <h3 style={{ marginTop: 0, fontSize: '16px', color: '#e65100' }}>📢 新規お知らせ作成</h3>
                <div style={{ marginBottom: '15px' }}>
                    <label style={{ fontSize: '12px', fontWeight: 'bold', color: '#666', display: 'block', marginBottom: '5px' }}>
                        タイトル（トップページの一行ニュースに表示）
                    </label>
                    <input 
                        value={title} 
                        onChange={e => setTitle(e.target.value)} 
                        placeholder="例：【重要】シミュレーター連動に向けた新ポジション設定のお願い" 
                    />
                </div>
                <div style={{ marginBottom: '15px' }}>
                    <label style={{ fontSize: '12px', fontWeight: 'bold', color: '#666', display: 'block', marginBottom: '5px' }}>
                        本文（詳細画面に表示）
                    </label>
                    <textarea 
                        value={content} 
                        onChange={e => setContent(e.target.value)} 
                        placeholder="お知らせの詳細な内容を入力してください。" 
                        rows="6" 
                    />
                </div>
                <button 
                    onClick={handleAdd} 
                    disabled={loading} 
                    className="btn" 
                    style={{ background: '#ff9800', color: 'white', fontWeight: 'bold', width: '100%' }}
                >
                    {loading ? '送信中...' : '公開する'}
                </button>
            </div>

            {/* 過去のお知らせ一覧 */}
            <div className="card">
                <h3 style={{ marginTop: 0, fontSize: '16px', marginBottom: '15px', paddingBottom: '10px', borderBottom: '1px solid #eee' }}>
                    📜 過去のお知らせ一覧
                </h3>
                {newsList.length === 0 ? (
                    <div style={{ textAlign: 'center', color: '#999', fontSize: '12px', padding: '20px' }}>
                        お知らせはまだありません
                    </div>
                ) : (
                    newsList.map(n => (
                        <div key={n.id} style={{ borderBottom: '1px solid #eee', paddingBottom: '15px', marginBottom: '15px' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '10px' }}>
                                <div style={{ fontWeight: 'bold', fontSize: '14px', flex: 1 }}>{n.title}</div>
                                <div style={{ display: 'flex', gap: '5px', flexShrink: 0 }}>
                                    <button 
                                        onClick={() => toggleActive(n.id, n.isActive)} 
                                        style={{ 
                                            background: n.isActive ? '#e8f5e9' : '#f5f5f5', 
                                            color: n.isActive ? '#2e7d32' : '#999', 
                                            border: n.isActive ? '1px solid #4caf50' : '1px solid #ccc',
                                            borderRadius: '4px', padding: '4px 8px', fontSize: '11px', cursor: 'pointer', fontWeight: 'bold' 
                                        }}
                                    >
                                        {n.isActive ? '👁️ 表示中' : '非表示'}
                                    </button>
                                    <button 
                                        onClick={() => handleDelete(n.id)} 
                                        style={{ background: '#ffebee', color: '#c62828', border: '1px solid #ef5350', borderRadius: '4px', padding: '4px 8px', fontSize: '11px', cursor: 'pointer', fontWeight: 'bold' }}
                                    >
                                        削除
                                    </button>
                                </div>
                            </div>
                            <div style={{ fontSize: '10px', color: '#999', margin: '5px 0' }}>
                                {new Date(n.createdAt).toLocaleString()}
                            </div>
                            <div style={{ fontSize: '12px', color: '#555', whiteSpace: 'pre-wrap', background: '#f9f9f9', padding: '10px', borderRadius: '6px', marginTop: '8px' }}>
                                {n.content}
                            </div>
                        </div>
                    ))
                )}
            </div>
        </div>
    );
};

export default AdminNews;